// extracted by mini-css-extract-plugin
module.exports = {"zygosity-type-wrapper":"VariantClassificationContainer_zygosity-type-wrapper__eYcXt"};